<template>
  <div :class="{'float-end ms-1': extra.display !== 'block', 'd-grid mb-1': extra.display === 'block'}">
    <button class="btn btn-lg" :class="getClass()" @click="buttonClick" :title="extra.parameters.name + '=' + $store.getters.device(extra.parameters.serial)[extra.parameters.name]">
      {{ title }}
      <div v-if="msg.id" class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      msg: {
        id: null,
        timeout: null
      }
    }
  },
  sockets: {
    controlDataStatus: function (data) {
      if (data.id === this.msg.id) {
        this.msg.id = null
        clearTimeout(this.msg.timeout)
        console.log('controlDataStatus:', data)
        if (data.success) {
          this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Käsklus edastatud!', showConfirmButton: false, timer: 1500 })
        } else {
          this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Tekkis viga!', text: data.message, showConfirmButton: false, timer: 2500 })
        }
      }
    }
  },
  methods: {
    getClass () {
      if (!this.extra.activeClass) {
        return this.extra.class
      } else {
        if (this.$store.getters.device(this.extra.parameters.serial)[this.extra.parameters.name] === 1) {
          return this.extra.activeClass
        } else {
          return this.extra.class
        }
      }
    },
    buttonClick () {
      this.msg.id = Date.now()
      this.extra.parameters.id = this.msg.id
      console.log('sent controlData:', this.extra.parameters)
      this.$socket.emit('controlData', this.extra.parameters)
      this.msg.timeout = setTimeout(this.msgTimeout, this.$store.state.msgTimeout)
    },
    msgTimeout () {
      this.msg.id = null
      this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Käsklust ei edastatud', showConfirmButton: false, timer: 1500 }, this.$store.state.msgTimeout)
    }
  }
}
</script>
